import React from 'react';
import { Calendar, ChevronRight } from 'lucide-react';
import { APPT_STATUS_COLORS } from '../crmShared';

function fmtTime(d) {
  if (!d) return '—';
  return new Date(d).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
}

export default function AppointmentsSection({ rows, count, isTeam, onSeeAll, onRowClick }) {
  const visible = (rows || []).slice(0, 5);

  if (!visible.length) {
    return (
      <div className="my-day-card">
        <SectionHeader count={count} onSeeAll={onSeeAll} />
        <p style={{ fontSize: 12, color: '#6C757D', margin: '12px 0 0', textAlign: 'center' }}>No appointments scheduled for today.</p>
      </div>
    );
  }

  return (
    <div className="my-day-card">
      <SectionHeader count={count} onSeeAll={onSeeAll} />
      <div style={{ marginTop: 8, display: 'flex', flexDirection: 'column', gap: 8 }}>
        {visible.map(a => {
          const statusColor = APPT_STATUS_COLORS[a.status] || '#6C757D';
          const patient = [a.first_name, a.last_name].filter(Boolean).join(' ') || 'Unknown';
          const clickable = onRowClick && a.contact_id;
          return (
            <div
              key={a.id}
              className={clickable ? 'my-day-row-clickable' : ''}
              onClick={clickable ? () => onRowClick(a) : undefined}
              role={clickable ? 'button' : undefined}
              tabIndex={clickable ? 0 : undefined}
              onKeyDown={clickable ? (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onRowClick(a); } } : undefined}
              style={{ display: 'flex', alignItems: 'center', gap: 10, background: '#F8F9FA', borderRadius: 10, padding: '8px 12px', boxShadow: '2px 2px 5px rgba(186,199,216,0.35), -2px -2px 5px rgba(255,255,255,0.8)' }}
            >
              <div style={{ textAlign: 'center', minWidth: 44 }}>
                <div style={{ fontSize: 13, fontWeight: 700, color: '#2E8B98' }}>{fmtTime(a.start_time)}</div>
                <div style={{ fontSize: 10, color: '#ADB5BD' }}>{fmtTime(a.end_time)}</div>
              </div>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontWeight: 600, fontSize: 12, color: '#212529', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{a.title}</div>
                <div style={{ fontSize: 11, color: '#6C757D', marginTop: 2 }}>{patient}{isTeam && a.assignee_name ? ` — ${a.assignee_name}` : ''}</div>
              </div>
              <span style={{ background: `${statusColor}18`, color: statusColor, padding: '2px 8px', borderRadius: 8, fontSize: 10, fontWeight: 700, textTransform: 'capitalize', flexShrink: 0 }}>
                {(a.status || 'scheduled').replace(/_/g, ' ')}
              </span>
            </div>
          );
        })}
      </div>
      {onSeeAll && <SeeAllLink onSeeAll={onSeeAll} />}
    </div>
  );
}

function SectionHeader({ count, onSeeAll }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 4 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
        <Calendar size={15} color="#2E8B98" />
        <span style={{ fontSize: 13, fontWeight: 700, color: '#212529' }}>Today's appointments</span>
        {count > 0 && <span className="my-day-count-badge active">{count}</span>}
        {count === 0 && <span className="my-day-count-badge">0</span>}
      </div>
    </div>
  );
}

function SeeAllLink({ onSeeAll }) {
  return (
    <button onClick={onSeeAll} style={{ display: 'flex', alignItems: 'center', gap: 3, marginTop: 10, background: 'none', border: 'none', color: '#2E8B98', fontSize: 12, fontWeight: 600, cursor: 'pointer', padding: 0 }}>
      See all <ChevronRight size={13} />
    </button>
  );
}
